import { render, staticRenderFns } from "./redirectUrl.vue?vue&type=template&id=50da347e&scoped=true"
import script from "./redirectUrl.vue?vue&type=script&lang=js"
export * from "./redirectUrl.vue?vue&type=script&lang=js"
import style0 from "./redirectUrl.vue?vue&type=style&index=0&id=50da347e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da347e",
  null
  
)

export default component.exports